<template>
    <div class="qtd" :class="{ 'qtd--compacto': compacto }">
        <v-btn
            icon
            :small="compacto"
            :disabled="menosDesabilitado"
            @click.stop="$emit('menos')"
        >
            <v-icon :small="compacto">mdi-minus</v-icon>
        </v-btn>

        <span class="qtd__valor">{{ valor }}</span>

        <v-btn
            icon
            :small="compacto"
            :disabled="maisDesabilitado"
            @click.stop="$emit('mais')"
        >
            <v-icon :small="compacto">mdi-plus</v-icon>
        </v-btn>
    </div>
</template>

<script>
/**
 * Contador de quantidade — pílula com borda, usado no rodapé do diálogo de produto
 * e em cada linha do carrinho.
 */
export default {
    name: 'ContadorQtd',

    props: {
        valor: {
            type: [Number, String],
            default: 1,
        },
        /**
         * Piso da quantidade. `null` desliga a trava: é o caso do carrinho, onde
         * apertar "−" em 1 **remove o item** em vez de ser uma operação inválida.
         */
        minimo: {
            type: Number,
            default: 1,
        },
        maisDesabilitado: {
            type: Boolean,
            default: false,
        },
        /** Versão de linha de lista: mesmos traços, menos altura. */
        compacto: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        menosDesabilitado() {
            if (this.minimo === null) return false;
            return +this.valor <= this.minimo;
        },
    },
};
</script>

<style scoped>
.qtd {
    display: flex;
    align-items: center;
    border: 2px solid rgba(128, 128, 128, 0.25);
    border-radius: 22px;
    padding: 2px;
    /* Não estica dentro de flex/list-item-action. */
    flex: none;
    width: max-content;
}

.qtd__valor {
    min-width: 30px;
    text-align: center;
    font-weight: 800;
    font-size: 16px;
}

.qtd--compacto .qtd__valor {
    min-width: 26px;
    font-size: 15px;
}
</style>
